import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Megaphone, TrendingUp } from 'lucide-react';
import AdsMonitorPage from './AdsMonitorPage';
import AgentActivityPanel from '@/components/AgentActivityPanel';
import EmptyState from '@/components/EmptyState';

export default function CampaignsPage({ embedded = false }) {
  return (
    <div className="animate-fade-in" data-testid="campaigns-page">
      {!embedded && (
        <div className="page-header mb-4">
          <h1 className="page-title">Campagne</h1>
          <p className="page-subtitle">Gestisci le campagne ADV a pagamento e le campagne organiche. Monitora performance, budget e conversioni.</p>
        </div>
      )}

      {!embedded && (
        <AgentActivityPanel
          agents={['ads_monitor_agent', 'outreach_executor']}
          areaLabel="Gestione campagne"
        />
      )}

      <Tabs defaultValue="ads" className="w-full">
        <TabsList className="bg-[#F8FAFC] border border-[#E2E8F0] mb-4">
          <TabsTrigger value="ads" className="flex items-center gap-1.5" data-testid="tab-ads">
            <Megaphone className="w-3.5 h-3.5" /> Campagne ADV
          </TabsTrigger>
          <TabsTrigger value="organic" className="flex items-center gap-1.5" data-testid="tab-organic">
            <TrendingUp className="w-3.5 h-3.5" /> Campagne Organiche
          </TabsTrigger>
        </TabsList>
        <TabsContent value="ads"><AdsMonitorPage embedded /></TabsContent>
        <TabsContent value="organic">
          <EmptyState icon={TrendingUp} title="Campagne organiche"
            description="Sequenze email, post LinkedIn pianificati e content calendar. Usa il tab Contenuti per creare i materiali, poi pianifica qui la distribuzione."
            actionLabel="Vai ai Contenuti" onAction={() => window.location.href = '/contents'} />
        </TabsContent>
      </Tabs>
    </div>
  );
}
